/** Centralised route path constants — use these instead of magic strings. */
export const ROUTES = {
  home: '/',

  // Public catalog (Iteration 3)
  search: '/search',
  property: (slug: string) => `/properties/${slug}`,
  credits: '/credits',

  // Auth (Iteration 2)
  login: '/login',
  signup: '/signup',
  forgotPassword: '/forgot-password',
  authCallback: '/auth/callback',

  // Booking flow (Iteration 4)
  book: (propertyId: string) => `/book/${propertyId}`,
  bookingConfirmed: (id: string) => `/booking/${id}/confirmed`,

  // Guest account (Iteration 5)
  account: {
    bookings: '/account/bookings',
    booking: (id: string) => `/account/bookings/${id}`,
    profile: '/account/profile',
  },

  // Extranet (Iteration 6)
  extranet: {
    root: '/extranet',
    property: (id: string) => `/extranet/properties/${id}`,
    propertyRooms: (id: string) => `/extranet/properties/${id}/rooms`,
    propertyCalendar: (id: string) => `/extranet/properties/${id}/calendar`,
    propertyPhotos: (id: string) => `/extranet/properties/${id}/photos`,
    propertyReservations: (id: string) => `/extranet/properties/${id}/reservations`,
    propertySettings: (id: string) => `/extranet/properties/${id}/settings`,
    onboarding: '/extranet/onboarding',
  },

  // Admin (Iteration 7)
  admin: {
    root: '/admin',
    properties: '/admin/properties',
    bookings: '/admin/bookings',
    users: '/admin/users',
    payouts: '/admin/payouts',
    settings: '/admin/settings',
  },
} as const
